import { useNavigate } from "react-router-dom";
import Permission from "../../../common/components/auth/Permission";
import { PiFiles } from "react-icons/pi";
import { FaMoneyBill } from "react-icons/fa";
import { MdQuestionMark } from "react-icons/md";
import { LuShoppingCart } from "react-icons/lu";
import { FaRegUser } from "react-icons/fa";
import { FiGitPullRequest } from "react-icons/fi";
import { GiReturnArrow } from "react-icons/gi";
import { GrServices } from "react-icons/gr";
import { FaFileInvoice } from "react-icons/fa6";
import { type ReactNode } from "react";

type ModuleCardProps = {
  icon: ReactNode;
  label: string;
  status: string;
  onClick: () => void;
};

const ModuleCard = ({ icon, label, status, onClick }: ModuleCardProps) => (
  <button
    type="button"
    onClick={onClick}
    className="group flex items-center gap-4 bg-white rounded-[14px] px-5 py-4
      transition-all duration-200 cursor-pointer text-left w-full
      hover:-translate-y-0.5 hover:shadow-md"
    style={{
      border: "0.5px solid rgba(0,0,0,0.08)",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.borderColor = "rgba(224,51,51,0.3)";
      e.currentTarget.style.backgroundColor = "rgba(224,51,51,0.04)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.borderColor = "rgba(0,0,0,0.08)";
      e.currentTarget.style.backgroundColor = "#fff";
    }}
  >
    <div
      className="flex items-center justify-center shrink-0 rounded-xl text-[#e03333]"
      style={{
        width: 44,
        height: 44,
        backgroundColor: "rgba(224,51,51,0.10)",
        fontSize: 20,
      }}
    >
      {icon}
    </div>
    <div className="flex flex-col min-w-0">
      <span className="text-gray-800 leading-snug" style={{ fontSize: 13, fontWeight: 500 }}>
        {label}
      </span>
      <span className="text-gray-400 mt-0.5" style={{ fontSize: 11 }}>
        {status}
      </span>
    </div>
  </button>
);

const PurchaseDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="relative w-full h-full overflow-y-auto bg-white text-black dark:text-black">
      <section className="w-full p-6">
        <header className="w-full pb-4 mb-6 border-b border-gray-200">
          <h2 className="text-3xl font-bold text-gray-800 tracking-tight">
            🛒 Módulo de Compras
          </h2>
        </header>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
          <Permission permission="view:inventory-categories">
            <ModuleCard
              icon={<PiFiles />}
              label="Categorias"
              status="Classificações de compra"
              onClick={() => navigate("/compras/categorias")}
            />
          </Permission>

          <Permission permission="view:inventory-suppliers">
            <ModuleCard
              icon={<LuShoppingCart />}
              label="Ordem de Compras"
              status="Pedidos em andamento"
              onClick={() => navigate("/compras/ordem")}
            />
          </Permission>

          <Permission permission="view:inventory-workorder">
            <ModuleCard
              icon={<FaRegUser />}
              label="Solicitantes"
              status="Usuários autorizados"
              onClick={() => navigate("/compras/solicitante")}
            />
          </Permission>

          <Permission permission="view:inventory-workorder">
            <ModuleCard
              icon={<FaMoneyBill />}
              label="Centro de Custos"
              status="Alocação financeira"
              onClick={() => navigate("/compras/centroDeCustos")}
            />
          </Permission>

          <Permission permission="view:inventory-workorder">
            <ModuleCard
              icon={<MdQuestionMark />}
              label="Sugestão de Compra"
              status="Reposição automática"
              onClick={() => navigate("/compras/sugestaoDeCompra")}
            />
          </Permission>

          <Permission permission="view:inventory-workorder">
            <ModuleCard
              icon={<GrServices />}
              label="Serviços Externos"
              status="Terceiros e prestadores"
              onClick={() => navigate("/compras/servicosExternos")}
            />
          </Permission>

          <Permission permission="view:inventory-workorder">
            <ModuleCard
              icon={<FiGitPullRequest />}
              label="Requisições de Compras"
              status="Solicitações pendentes"
              onClick={() => navigate("/compras/requestordem")}
            />
          </Permission>

          <Permission permission="view:inventory-workorder">
            <ModuleCard
              icon={<GiReturnArrow />}
              label="Devoluções de Compra"
              status="Itens devolvidos"
              onClick={() => navigate("/compras/devolucao")}
            />
          </Permission>

          <Permission permission="view:inventory-workorder">
            <ModuleCard
              icon={<FaFileInvoice />}
              label="Notas Fiscais de Entrada"
              status="Documentos fiscais"
              onClick={() => navigate("/compras/NFSEntry")}
            />
          </Permission>
        </div>
      </section>
    </div>
  );
};

export default PurchaseDashboard;
